import React from "react";
import _ from "lodash/fp";
import ellipsesVertical from "@ingka/ssr-icon/paths/ellipses-vertical";
import Button from "@ingka/button";
import Tooltip from "@ingka/tooltip";

type Props = {
	onClick?: () => void;
	title?: string;
};

const MenuButton: React.FunctionComponent<Props> = ({ onClick = _.noop, title }: Props) => {
	return (
		<Tooltip interactiveCustomTrigger tooltipText={title ? title : ""}>
			<Button
				text={title ? title : "button"}
				type="tertiary"
				onClick={onClick}
				size="small"
				iconOnly
				ssrIcon={ellipsesVertical}
			/>
		</Tooltip>
	);
};

export default MenuButton;
